import { Button } from "components/Button/Button";
import { Loading } from "components/Loading/loading";
import React, { useEffect, useRef, useState } from "react";
import { DynamicFormTranslate, getFormByKey } from "../../api";
import { InputDetector } from "../InputDetector";
import { getFormInformationById, postDataForm, putInformationForm, getFormInformationByReferenceId, getDataForPrint, putInformationFormWorkflow } from "./api";
import './style.scss';
import { Textbox } from "components/Textbox/Textbox";
import { Message } from "components/Message/Message";
import { InputTypes, MessageType } from "types/enum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ICON_TYPE } from "utils/constants";
import { GroupingPriceFunction, RoundWithExcelMethod, trans } from "utils/helpers";

interface DynamicFormDataEntryPropes {
    formKey:string;
    defaultInputList?:any;
    formBuilderMode?:boolean;
    id?:string;
    jobId?:string;
    ReferenceId?:string;
    PRJ_UID?:any;
    mode:'create' | 'view' | 'edit';
    copyPermission?:boolean;
    EnableDisplacement?:boolean;
    firstAutoValue?:boolean;
    step?:any, 
    onHide?:(e:boolean)=>void;
    handleCopy?:(formKey:any)=>void;
    handleShowReferenceStepper?:(referenceId:any)=>void;
    parentISCartable?:any
    dataEntry?:boolean
    modalFormLabelCallBack?:any
    formBuilderPage?:any
    buttonPrintObjCallBack?:(obj:any)=>void
    handleCallAttachment?:any
    reload?:any
    callAttachmentMoveTemp?:any
    setShowAttachmentByDynamicForm?:any
}
/// <summary>
/// when step is null we ignore Step logic 
/// </summary>

export const DynamicFormDataEntry = ({formKey,setShowAttachmentByDynamicForm,callAttachmentMoveTemp,reload,buttonPrintObjCallBack,handleCallAttachment,formBuilderPage=false,modalFormLabelCallBack,dataEntry=false,parentISCartable=false,firstAutoValue=true,step=null,ReferenceId, EnableDisplacement=false,formBuilderMode=false,defaultInputList,copyPermission=false,id,jobId,PRJ_UID,handleCopy,onHide,mode ,handleShowReferenceStepper}:DynamicFormDataEntryPropes) => {
    const [inputs,setInputs] = useState<any>([])
    const [data,setData] = useState<any>([])
    const [loading,setLoading] = useState<boolean>(true)
    const [dataLoading,setDataLoading] = useState<boolean>(true)
    const [times,setTimes] = useState<any>({})
    const [rowsData,setRowsData] = useState<any>({})
    const [openStepStatus,setOpenStepStatus] = useState<any>({})
    const [DynamicFormData, setDynamicFormData] = useState<any>({});
    const [catchMessage, setCatchMessage] = useState<any>({type:"info",msg:"NoDataForPreview"});
    const DynamicFormRef = useRef<any>();
    const FormulaObjectRef = useRef<any>({});

    const newObj=useRef<any>()
    const conditionObjectRef = useRef<any>({});
    const selectedFromDynamicDictionary=useRef<any>()
    const preventExecute=useRef<any>(false)

    
 

 function CalculateCallBack(value , inputKey,haveTag=false,obj={}){ 



    let val=haveTag ?DynamicFormRef.current?.[inputKey]?.value?DynamicFormRef.current?.[inputKey]?.value:value:value
         if(val !=null && value!=undefined){

            if(/^\d+(\.\d+)?$/.test(val?.toString())){
                newObj.current={...newObj.current,[inputKey] :+val}
            }
            else{
                newObj.current={...newObj.current,[inputKey] :val}
            }
        }
            if(!!Object.keys(obj)?.length){
                newObj.current={...newObj.current,[inputKey+'Object'] :obj}
                       setTimeout(() => {   
                    DynamicFormRef.current?.[inputKey].dispatchEvent(new Event('input', { bubbles: true }));
             }, 0);
            }
          selectedFromDynamicDictionary.current=inputKey
    }
    
    
    const handleInput = (event) => {    
    try{
            newObj.current={...newObj.current,[event.target.name]:event.target?.type=='number'?+event.target?.value:event?.target?.type=='checkbox'?
                event?.target?.checked==true?1:0:event.target?.value
            }
            






    //این شرطو چرا گذاشتیم؟ توی مد ادیت به محض باز شدن فرم اگر یکی از اینپوت ها دارای فرمول باشد که توی فرمول از یک داینامیک دیکشنری استفاده کرده باشیم چون آنچینج داینامیک دیکشنری صدا زده میشه و بعدش باعث میشه هنئل اینپوت صدا زده بشه میاد اون فیلدی که فرموا داشتو دوباره حساب میکنه درحالتی ک نباید حساب کنه چون شاید مقدارش دستی باشه و اصلا با فرموا نخواسته باشیم بزنیم       
 if(mode!='edit'|| (mode=='edit' &&JSON.stringify(Object.values(FormulaObjectRef.current))?.includes(selectedFromDynamicDictionary?.current) && preventExecute.current) || !JSON.stringify(Object.values(FormulaObjectRef.current))?.includes(selectedFromDynamicDictionary?.current))
 
 
    {
            for (let key in FormulaObjectRef.current) {
                



            if(FormulaObjectRef.current[key]!="string" && FormulaObjectRef.current[key]!="newObj.current?.string" && DynamicFormRef.current[key]){
              const isPrice= inputs.flatMap(item=>item.inputList).find(item=>item?.SystemKey==key)   
              let preValue = DynamicFormRef.current[key].value
              const activeElement=event.target.tagName === "INPUT"?event.target:  document.activeElement   as any
              




                
              if(activeElement?.name==key ||
                ( !FormulaObjectRef.current[key].includes(activeElement?.name) && activeElement.name)||
                 (!FormulaObjectRef.current[key].includes(selectedFromDynamicDictionary?.current) 
                    && selectedFromDynamicDictionary?.current 
                    && (!activeElement.name || activeElement.name==selectedFromDynamicDictionary.current)
                )
            
            ){
                
                   if(isPrice?.initialSystemKey=="price"){
                    
                    
                    }else{

                              
 const result=DynamicFormRef.current[key].value || ""
                                DynamicFormRef.current[key].value =  result?.toString()?.includes("undefined") || !result?'':result
                                newObj.current={...newObj.current,[key]:DynamicFormRef.current[key].type=="number"?
                                    result?.toString()?.includes("undefined") || !result?0:+result
                                   :result?.toString()?.includes("undefined") || !result?'':result }



                        }}
             else
                {
       

                    if(isPrice?.initialSystemKey=="price"){
                        const result=GroupingPriceFunction(isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace==0? RoundWithExcelMethod((data?.[key] && mode=='view')?data?.[key]: (eval(FormulaObjectRef.current[key])!= Infinity?eval(FormulaObjectRef.current[key]):preValue ),isPrice?.currencyRoundingPlace):(data?.[key] && mode=='view')?data?.[key]: (eval(FormulaObjectRef.current[key])!= Infinity?eval(FormulaObjectRef.current[key]):preValue ))
                        DynamicFormRef.current[key].value =result?.toString()?.includes("undefined") || !result?'0':result
                       
                        newObj.current={...newObj.current,[key]:

                           result?.toString()?.includes("undefined") || !result?'0':result
                        }
                              }else{

                                
const result=data?.[key] && mode=='view'?data?.[key]: eval(FormulaObjectRef.current?.[key])!= Infinity?eval(FormulaObjectRef.current?.[key]):preValue
                                  DynamicFormRef.current[key].value = result?.toString()?.includes("undefined")|| !result?'':result 
                                  newObj.current={...newObj.current,[key]:
                                    DynamicFormRef.current[key].type=="number"?result?.toString()?.includes("undefined") || !result?0:+result 
                                 
                                    
                                    :   
                                    
                                  result?.toString()?.includes("undefined") || !result?'':result  }
                                }
                                    setTimeout(() => {
                                        if((eval(FormulaObjectRef.current[key])||eval(FormulaObjectRef.current[key])==0) &&(preValue==""? true :  preValue !=eval(FormulaObjectRef.current[key])) && eval(FormulaObjectRef.current[key]) != Infinity ){
                                            DynamicFormRef.current[key].dispatchEvent(new Event('input', { bubbles: true }));
  
                                        }
                                    }, 0);
                                }     
                                
                            }







                        }
                    }else{
                        preventExecute.current=true
                    }
                //        newObj.current={...newObj.current,[event.target.name]:event.target?.value}
      //  setData({...data ,...newObject })
       selectedFromDynamicDictionary.current=null
    }
    catch{}
  
       
       

       
    };

//     useEffect(()=>{
//         if(Object.keys(FormulaObjectRef.current)){
           

// Object.keys(FormulaObjectRef.current).map(item=>{
//    let x=DynamicFormRef.current ? (DynamicFormRef.current?.[item] as any)?.value =eval(FormulaObjectRef.current?.[item])}):null

//         }
//     },[Object.keys(FormulaObjectRef.current).map(item=>DynamicFormRef.current?.[item]?.value)])
    
    const handleSubmit = async(event,withAttach=null,showReferenceStepper=false) => {  
        event.preventDefault()
        if(DynamicFormRef.current.reportValidity() ){
          const obj :any= {}
        const DataGrids :any= {}
        inputs.map(card=>{
            card?.inputList.map(input=>{
          if( (conditionObjectRef.current?.[input.SystemKey]?.length > 0 ?eval(conditionObjectRef.current?.[input.SystemKey]) : true ) && (conditionObjectRef.current?.[input.StepIndex]?.length > 0 ?eval(conditionObjectRef.current?.[input.StepIndex]) : true ) &&  (step == card.stepNumber||step==null||step=="")&&input?.SystemKey !=undefined &&input.typeName != 'step'  ){
                    if(input.typeName == 'textArea'|| input.typeName == 'items' || input.typeName == 'activityStatus' ||input.typeName == 'SystemNumber' || input.typeName == 'selectBox' || input.typeName == 'apiRequestConfigurator' ||input.typeName == 'text'|| input.typeName == 'number' || input.typeName === "decimalNumber" || input.typeName == 'price' ||  input.typeName == 'RadioButton'||  input.typeName == 'radio' ){
                    obj[input.SystemKey] =input.typeName == 'price'?DynamicFormRef.current[input.SystemKey].value?DynamicFormRef.current[input.SystemKey].value?.replaceAll(',',''):null
                    : (input.typeName == 'text' && input?.InputType == 6 ) ? DynamicFormRef.current[input.SystemKey].value  :DynamicFormRef.current[input.SystemKey].value? DynamicFormRef.current[input.SystemKey].value :null 
                }else if(input.typeName == 'timeLength'){
                    obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey][0].value ?DynamicFormRef.current[input.SystemKey][0].value:null
                }else if(input.typeName == 'checkBox'){
                    obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey].checked+""
                }else if(input.typeName == 'date' ||input.typeName == 'time' ){
                    obj[input.SystemKey] = times[input.SystemKey] ?times[input.SystemKey]:null   
                }else if(input.typeName == 'Position' ||input.typeName == 'Person' ){
                    obj[input.SystemKey+"Description"] =  DynamicFormRef.current[input.SystemKey+"Description"].value
                    obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey].value  ?DynamicFormRef.current[input.SystemKey].value    :null  
                }
                else if(input.typeName == 'slider'){
                    obj[input.SystemKey] = +DynamicFormRef.current[input.SystemKey].value ?+DynamicFormRef.current[input.SystemKey].value:null 
                } else if(input.type == 16){
                    DataGrids[input.SystemKey] = rowsData[input.SystemKey]   
                }else if (input.typeName == 'PositionDictionary') {
                    obj[input.SystemKey] = DynamicFormRef.current?.["RequesterPositionId"].value ?DynamicFormRef.current?.["RequesterPositionId"].value:null;
                    obj["RequesterPositionDescription"] = DynamicFormRef.current["PositionDictionaryDescription"].value;
                  //  obj.typeNames={...obj.typeNames,[input.SystemKey]:input.typeName}
                 }else if(input.backendType == 'guid'||input.type==InputTypes.DynamicDictionary ) {
                    obj[input.SystemKey+"Description"] =  DynamicFormRef.current[input.SystemKey+"Description"].value
                   // obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey].value?DynamicFormRef.current[input.SystemKey].value:null  
                  
                    obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey+"value"]?.value? DynamicFormRef.current[input.SystemKey+"value"].value:(DynamicFormRef.current[input.SystemKey]?.value ?DynamicFormRef.current[input.SystemKey]?.value:null)  

                 }
                 else if(input.typeName == 'url') {
                    if(input?.inputType=="AutoCompleteDictionary")   obj[input.SystemKey+"Description"] =  DynamicFormRef.current['browser'+input.SystemKey].value
                   // obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey].value?DynamicFormRef.current[input.SystemKey].value:null  
                    obj[input.SystemKey] =  DynamicFormRef.current[input.SystemKey]?.value?DynamicFormRef.current[input.SystemKey].value:null

                 }
            }
            })
        })
    //  inputs.flatMap(item => item.inputList).map((input)=>{
    //             if( (conditionObjectRef.current?.[input.SystemKey]?.length > 0 ?eval(conditionObjectRef.current?.[input.SystemKey]) : true ) && (conditionObjectRef.current?.[input.StepIndex]?.length > 0 ?eval(conditionObjectRef.current?.[input.StepIndex]) : true ) &&  (step == input.StepIndex||step==null||step=="")&&input?.SystemKey !=undefined &&input.typeName != 'step'  ){
    //                 if(input.typeName == 'textArea'|| input.typeName == 'SystemNumber' || input.typeName == 'selectBox' ||input.typeName == 'text'||input.typeName == 'number' || input.typeName == 'price' ||  input.typeName == 'RadioButton'||  input.typeName == 'radio' ){
    //                 obj[input.SystemKey] = (input.typeName == 'text' && input?.InputType == 6 ) ? event.target[input.SystemKey].value  : event.target[input.SystemKey].value  
    //             }else if(input.typeName == 'timeLength'){
    //                 obj[input.SystemKey] = event.target[input.SystemKey][0].value 
    //             }else if(input.typeName == 'checkBox'){
    //                 obj[input.SystemKey] = event.target[input.SystemKey].checked+""
    //             }else if(input.typeName == 'date' ||input.typeName == 'time' ){
    //                 obj[input.SystemKey] = times[input.SystemKey]    
    //             }else if(input.typeName == 'Position' ||input.typeName == 'Person' ){
    //                 console.log("input.SystemKey+ " ,input.SystemKey+"Description")
    //                 obj[input.SystemKey+"Description"] =  event.target[input.SystemKey+"Description"].value
    //                 obj[input.SystemKey] = event.target[input.SystemKey].value    
    //             }
    //             else if(input.typeName == 'slider'){
    //                 obj[input.SystemKey] = +event.target[input.SystemKey].value  
    //             } else if(input.type == 16){
    //                 DataGrids[input.SystemKey] = rowsData[input.SystemKey]   
    //             }else if (input.typeName == 'PositionDictionary') {
    //                 obj[input.SystemKey] = event.target?.["RequesterPositionId"].value;
    //                 obj["RequesterPositionDescription"] = event.target["PositionDictionaryDescription"].value;
    //               //  obj.typeNames={...obj.typeNames,[input.SystemKey]:input.typeName}
    //              }else if(input.backendType == 'guid'||input.type==InputTypes.DynamicDictionary ) {
    //                 obj[input.SystemKey+"Description"] =  event.target[input.SystemKey+"Description"].value
    //                // obj[input.SystemKey] = event.target[input.SystemKey].value?event.target[input.SystemKey].value:null  
                  
    //                 obj[input.SystemKey] = event.target[input.SystemKey+"value"]?.value? event.target[input.SystemKey+"value"].value:(event.target[input.SystemKey]?.value ?event.target[input.SystemKey]?.value:null)  

    //              }
    //         }
    //     })
        if(mode == 'edit'){          
            if(ReferenceId)  {
                await  putInformationFormWorkflow(ReferenceId,formKey,` ${JSON.stringify({JsonData :obj ,PRJ_UID: PRJ_UID,DataGrids:DataGrids })} `)
            }else{
                await  putInformationForm(id,formKey,` ${JSON.stringify({JsonData :obj ,PRJ_UID: PRJ_UID,DataGrids:DataGrids })} `)

            }
            onHide && onHide(true)   
            }else if(mode == 'create'){
                const res = await postDataForm(formKey,` ${JSON.stringify({JsonData :obj ,PRJ_UID: PRJ_UID,DataGrids:DataGrids })} ` ,PRJ_UID,withAttach?true:false)
                
                if (showReferenceStepper) {
                    handleShowReferenceStepper && handleShowReferenceStepper(!(res.MessageType ==MessageType.success) ? false:res.Data);
                } else {
                    onHide && onHide(true) 
                }
                
                      if(res.Data){ callAttachmentMoveTemp &&   callAttachmentMoveTemp(res.Data)
        }
          reload && reload ()
            }
            try {
           
        } catch (error) {
            
        }
            
        }
     
    }

// const CalculateRoundingPlace=(e)=>{
//     let newObject:any ={};
//     for (let key in FormulaObjectRef.current) {
//         if(FormulaObjectRef.current[key]!="string" && FormulaObjectRef.current[key]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current[key]){
//           const isPrice= inputs.flatMap(item=>item.inputList).find(item=>item?.SystemKey==key)
//                 DynamicFormRef.current[key].value =GroupingPriceFunction( RoundWithRoundingPlace(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace))
//             let preValue =GroupingPriceFunction(RoundWithRoundingPlace(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace)) 
//             setTimeout(() => {
//                 if((eval(FormulaObjectRef.current[key])||eval(FormulaObjectRef.current[key])==0) &&(preValue==0? true :  preValue !=eval(FormulaObjectRef.current[key])) && eval(FormulaObjectRef.current[key]) != Infinity ){
//                     DynamicFormRef.current[key].dispatchEvent(new Event('input', { bubbles: true }));

//                     }
//              }, 0);
//           //  newObject = {...newObject , [key]: RoundWithRoundingPlace(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace)}
//         }
//         }


    
// }


const CalculateRoundingPlace=(e,systemKey)=>{
    

        if(FormulaObjectRef.current?.[systemKey]!="string" && FormulaObjectRef.current?.[systemKey]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current?.[systemKey]){
          const isPrice= inputs.flatMap(item=>item.inputList).find(item=>item?.SystemKey==systemKey)          
          DynamicFormRef.current[systemKey].value =GroupingPriceFunction(isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace==0? RoundWithExcelMethod(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace):e?.replaceAll(',','') || 0)
          let preValue =GroupingPriceFunction(isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace==0?RoundWithExcelMethod(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace):e?.replaceAll(',','') || 0) 
          setTimeout(() => {
              //  if((eval(FormulaObjectRef.current?.[systemKey])||eval(FormulaObjectRef.current?.[systemKey])==0) &&(preValue==0? true :  preValue !=eval(FormulaObjectRef.current?.[systemKey])) && eval(FormulaObjectRef.current?.[systemKey]) != Infinity ){
                    DynamicFormRef.current?.[systemKey].dispatchEvent(new Event('input', { bubbles: true }));

                   // }
             }, 0);
             newObj.current={...newObj.current,[systemKey]:GroupingPriceFunction(isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace==0? RoundWithExcelMethod(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace):e?.replaceAll(',','') || 0)
                        }
        }
}






const setCodeCallback=(object,systemKey)=>{

    


    newObj.current={...newObj.current,[systemKey+'Object']:object}


    
    DynamicFormRef.current[systemKey].value =object?.Code

    // DynamicFormRef.current[systemKey].value =eval(FormulaObjectRef.current[systemKey])!= Infinity?eval(FormulaObjectRef.current[systemKey]): Object.values(object)[0]
    //    if(dependencyObjectRef.current?.[systemKey]!="string" && dependencyObjectRef.current?.[systemKey]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current?.[systemKey]){
       
        setTimeout(() => {
              //  if((eval(FormulaObjectRef.current?.[systemKey])||eval(FormulaObjectRef.current?.[systemKey])==0) &&(preValue==0? true :  preValue !=eval(FormulaObjectRef.current?.[systemKey])) && eval(FormulaObjectRef.current?.[systemKey]) != Infinity ){
                    DynamicFormRef.current?.[systemKey].dispatchEvent(new Event('input', { bubbles: true }));

                   // }
             }, 0);
    
//     for (let key in dependencyObjectRef.current) {


// if( dependencyObjectRef.current[key]?.split('.')?.[0]==systemKey){
// let x=dependencyObjectRef.current[key]?.replaceAll([systemKey],"object")


//            // if(FormulaObjectRef.current[key]!="string" && FormulaObjectRef.current[key]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current[key]){
//             let preValue = DynamicFormRef.current[key].value
                  
//              DynamicFormRef.current[key].value = (data?.[key] && mode=='view')?data?.[key]: (eval(x)!= Infinity?eval(x):preValue )
                                
//               setTimeout(() => {
//                 if((eval(x)||eval(x)==0) &&(preValue==""? true :  preValue !=eval(x)) && eval(x) != Infinity ){
//                     DynamicFormRef.current[key].dispatchEvent(new Event('input', { bubbles: true }));

//                     }
//              }, 0);
        
//         //}
//        // }
//       //  setData({...data ,...newObject })
//        selectedFromDynamicDictionary.current=null








      
//         }
// }


}




    async function getFormByKeyAsync(formKey) {
        setLoading(false)
        try{
          
          const respons = await getFormByKey(formKey,ReferenceId as any , PRJ_UID,parentISCartable,formBuilderPage)
          setInputs(JSON.parse( respons.Data?.DynamicForms.FormFields)?.inputList)
         setShowAttachmentByDynamicForm && setShowAttachmentByDynamicForm(JSON.stringify(
         JSON.parse( respons.Data?.DynamicForms.FormFields)?.inputList.flatMap(item=>item.inputList)
          ).includes('initialSystemKey":"attachment'))
          FormulaObjectRef.current = JSON.parse( respons.Data?.DynamicForms.FormFields)?.formula
          conditionObjectRef.current = JSON.parse( respons.Data?.DynamicForms.FormFields)?.condition
          setCatchMessage({type:"info",msg:"NoDataForPreview"})
          JSON.parse( respons.Data?.DynamicForms.FormFields)?.inputList.flatMap(item=>item.inputList).map(item=>{
            item?.defaultValue?
                        item.typeName=="number" || item.typeName=="decimalNumber" || item.typeName=="price"?newObj.current={...newObj.current,[item.SystemKey]:+item?.defaultValue}:newObj.current={...newObj.current,[item.SystemKey]:item?.defaultValue}
            :
            item.typeName=="number" || item.typeName=="decimalNumber" || item.typeName=="price"?newObj.current={...newObj.current,[item.SystemKey]:0}:newObj.current={...newObj.current,[item.SystemKey]:""}
          })

        }catch(err:any){
            setCatchMessage({type:"error" , msg:err?.response?.data?.Message})

        }
        setLoading(true)
      }


    async function getFormInformationAsync() {
        setDataLoading(false)
        try{
            if(ReferenceId){
                const respons = await getFormInformationByReferenceId((ReferenceId),formKey)
                setData({...respons?.Data.DynamicFormData , ...respons?.Data.DataGrids})
                 buttonPrintObjCallBack&& buttonPrintObjCallBack({
                  Id: respons.Data.DynamicFormData.Id,
                  reportDomain:"DynamicForm",
                  objectTag:formKey,
                  apiFunction:getDataForPrint,
                  params:{formKey:formKey}
                })
                
            }else{
                const respons = await getFormInformationById((id),formKey)
                setData({...respons?.Data.DynamicFormData , ...respons?.Data.DataGrids})
                     buttonPrintObjCallBack&& buttonPrintObjCallBack({
                      Id: respons.Data.DynamicFormData.Id,
                      reportDomain:"DynamicForm",
                      objectTag:formKey,
                      apiFunction:getDataForPrint,
                      params:{formKey:formKey},
                    })
            }
          setCatchMessage({type:"info",msg:"NoDataForPreview"})
          
          }catch(err:any){
            setCatchMessage({type:"error" , msg:err?.response?.data?.Message})

          }
          
          setDataLoading(true)
    }
    

    const DynamicFormTranslateAsync=async()=>{
        try{
            const response=await DynamicFormTranslate(formKey)
            modalFormLabelCallBack(response?response:'')
        }
        catch(error){}
    }
    useEffect(()=>{
        if(mode != 'create'&&(jobId ||id||ReferenceId)) {
            getFormInformationAsync()
        }
        if(defaultInputList){
            setInputs(defaultInputList)
        }else{
            getFormByKeyAsync(formKey)
        }
        if(dataEntry){
            DynamicFormTranslateAsync()
        }
    },[defaultInputList])

    

    return ( 

        <>
        {(loading&&dataLoading) ?
           <>
           {(inputs&& data)?
            <form ref={ DynamicFormRef} action=""  onSubmit={(e)=>{handleSubmit(e)}} onInput={handleInput}>
                <div className="card mx-2 mt-1 formBuilder__formBx" style={{height:'fit-content'}}>
                    <div className="row">
                       {inputs.map((card , cardIndex)=>(
                         <React.Fragment key={cardIndex}>
                         {(step >= card.stepNumber||step==null||step=="") ? 
                         <div  
                         style={{minHeight:openStepStatus[cardIndex]===false?"0px":"100px" , flexDirection:"row"}} className={`card row mx-0  px-0  
                              ${(conditionObjectRef.current?.[card.SystemKey] &&( !eval(conditionObjectRef.current?.[card.SystemKey])) )?"noneImpo" :"d-flex"}
                         `}>
                       <div style={{ backgroundColor: "#cfe2ff", paddingRight: "20px", justifyContent: "space-between" }} className={`formBuilder__formBx__items not-active  d-flex  py-1 col-12 pr-4`}>
                               <div>{card.label=='card'?trans(card.label):card.label  } </div>
                           <div style={{ marginLeft: "18px" }} onClick={() => setOpenStepStatus(pre=>{return{...pre ,[cardIndex]:(pre[cardIndex]||pre[cardIndex]==undefined)? false : true}})} >{(openStepStatus[cardIndex]===false )? <FontAwesomeIcon icon={[ICON_TYPE, "angle-down"]} size="lg" className="icon" /> : <FontAwesomeIcon icon={[ICON_TYPE, "angle-up"]} size="lg" className="icon" />}</div>
                       </div>
                        <>
                        
                         {card.inputList.map((Obj, index) => {
                            if ((Obj.typeName=="button" && window.location.href.includes('cartable')) || Obj.typeName=="attachment") return null
                           return (
                                <React.Fragment key={index}>
                                 <div key={index} id={"inputsId"+index}
                                   
                                  className={` align-items-start formBuilder__formBx__active col-${Obj.size} formBoxDr in   ${( openStepStatus[cardIndex]===false  ||(conditionObjectRef.current?.[Obj.SystemKey]?.length > 0 && !eval(conditionObjectRef.current?.[Obj.SystemKey]))||
                                    (conditionObjectRef.current?.[Obj.StepIndex]?.length > 0 && !eval(conditionObjectRef.current?.[Obj.StepIndex])))?"noneImpo" :"d-flex"}
                                    `}  >
                                 <div className={`d-flex ${Obj.typeName == 'checkBox' ?'align-items-center' :'align-items-start'} h-100 justify-content-between w-100 formBoxDr iwn`} id={index}>
                                     <InputDetector
                                     setCodeCallback={setCodeCallback}
                                     CalculateRoundingPlace={CalculateRoundingPlace}
                                     onClick={Obj.typeName=="button" && Obj?.viewAttachment?(e)=>{
                                         e.preventDefault()
                                        if(mode=="edit"){//اگر فرم در مد مشاهده یا ادیت باز شود دیگه نباید با کلیک روی دکمه داینامیک  ، فرم و ارسال کنیم و فقط باید پیوست باز بشه و اگر در مد ایجاد باشه باید هم ارسال بشه و هم پیوست باز بشه
                            
                                            handleCallAttachment(ReferenceId)
                                             onHide && onHide(true) 

                                        }else if(mode=='create'){
                                            handleSubmit(e,'withAttach' as any)
                                        }
                                        
                                    }:()=>{
                                   
                                     }} 
                                     
                             

                                     useOnInput={true}  handleOpenStep={(e)=>{setOpenStepStatus(pre=>{return{...pre ,[Obj.StepIndex]:e }})}} CalculateCallBack={CalculateCallBack} dataEntry={dataEntry} mode={((step > card.stepNumber &&(step!=null||step!="") || Obj.SystemKey=='SystemNumber') ? "view" :mode)  }    typeName={Obj.typeName}  property={{ ...Obj, defaultValue:
                                        
                                    //     Obj.initialSystemKey=="price"?
                                        
                                    //    Obj?.currencyRoundingPlace || Obj?.currencyRoundingPlace==0? RoundWithExcelMethod(data?.[Obj.SystemKey]?  (data?.[Obj.SystemKey]+"")?.replaceAll(',',''):Obj?.defaultValue?.replaceAll(',',''),Obj?.currencyRoundingPlace):data?.[Obj.SystemKey]?data?.[Obj.SystemKey]+""?.replaceAll(',',''):Obj?.defaultValue?.replaceAll(',','')
                                        
                                    //     :
                                        
                                        data?.[Obj.SystemKey]?data?.[Obj.SystemKey]:Obj?.defaultValue
                                    
                                    
                                    
                                    
                                    }}  handleRowsData={(e)=>{setRowsData({...rowsData ,[Obj?.SystemKey]: e })}} handleTime={(e) => { setTimes({ ...times, [Obj.SystemKey]: e }); } } changeProperty={function (e: any): void {
                                           throw new Error("Function not implemented.");
                                        } }/>  
                                 </div>
                                 </div>
                            </React.Fragment>
                           );
                         })}                          
                        </>
                         </div>

                                :
                         <></>
                         
                         
                         }

                         </React.Fragment>
                       ))}
       
                    </div>
                <div className="col-lg-12 btns_form">
                    {mode != 'view' ?
                        <div className="py-2"> 
                          
                         {(handleShowReferenceStepper &&     (step==1 || mode == "create")) && (
                            <Button
                              btnType="submit"
                              value="SaveAndReference"
                              onClick={(e) => {handleSubmit(e,null,true);}}
                            />
                          )}
                            <Button btnType="submit" value="Save" onClick={handleSubmit}/>
                            <Button btnType="cancel" value="cancel" onClick={()=>{onHide && onHide(false)}} /> 
                        </div>
                    :
                    <div className="m-1">
                        {/* <Button btnType="primary" value="copy" onClick={()=>{handleCopy && handleCopy(formKey)}} /> */}
                        <Button btnType="primary" value="close" onClick={()=>{onHide && onHide(false)}} /> 
                    </div>
                    }
                </div> 
            </div>
            </form>
           : <Message message={catchMessage.msg} type={catchMessage.type} />
           }
           </>
           :
           <Loading />
        }
        </>
     );
}


















































// import { Button } from "components/Button/Button";
// import { Loading } from "components/Loading/loading";
// import React, { useEffect, useRef, useState } from "react";
// import { DynamicFormTranslate, getFormByKey } from "../../api";
// import { InputDetector } from "../InputDetector";
// import { getFormInformationById, postDataForm, putInformationForm, getFormInformationByReferenceId, getDataForPrint, putInformationFormWorkflow } from "./api";
// import './style.scss';
// import { Textbox } from "components/Textbox/Textbox";
// import { Message } from "components/Message/Message";
// import { InputTypes, MessageType } from "types/enum";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { ICON_TYPE } from "utils/constants";
// import { GroupingPriceFunction, RoundWithExcelMethod, trans } from "utils/helpers";

// interface DynamicFormDataEntryPropes {
//     formKey:string;
//     defaultInputList?:any;
//     formBuilderMode?:boolean;
//     id?:string;
//     jobId?:string;
//     ReferenceId?:string;
//     PRJ_UID?:any;
//     mode:'create' | 'view' | 'edit';
//     copyPermission?:boolean;
//     EnableDisplacement?:boolean;
//     firstAutoValue?:boolean;
//     step?:any, 
//     onHide?:(e:boolean)=>void;
//     handleCopy?:(formKey:any)=>void;
//     handleShowReferenceStepper?:(referenceId:any)=>void;
//     parentISCartable?:any
//     dataEntry?:boolean
//     modalFormLabelCallBack?:any
//     formBuilderPage?:any
//     buttonPrintObjCallBack?:(obj:any)=>void
//     handleCallAttachment?:any
//     reload?:any
//     callAttachmentMoveTemp?:any
//     setShowAttachmentByDynamicForm?:any
// }
// /// <summary>
// /// when step is null we ignore Step logic 
// /// </summary>

// export const DynamicFormDataEntry = ({formKey,setShowAttachmentByDynamicForm,callAttachmentMoveTemp,reload,buttonPrintObjCallBack,handleCallAttachment,formBuilderPage=false,modalFormLabelCallBack,dataEntry=false,parentISCartable=false,firstAutoValue=true,step=null,ReferenceId, EnableDisplacement=false,formBuilderMode=false,defaultInputList,copyPermission=false,id,jobId,PRJ_UID,handleCopy,onHide,mode ,handleShowReferenceStepper}:DynamicFormDataEntryPropes) => {
//     const [inputs,setInputs] = useState<any>([])
//     const [data,setData] = useState<any>([])
//     const [loading,setLoading] = useState<boolean>(true)
//     const [dataLoading,setDataLoading] = useState<boolean>(true)
//     const [times,setTimes] = useState<any>({})
//     const [rowsData,setRowsData] = useState<any>({})
//     const [openStepStatus,setOpenStepStatus] = useState<any>({})
//     const [DynamicFormData, setDynamicFormData] = useState<any>({});
//     const [catchMessage, setCatchMessage] = useState<any>({type:"info",msg:"NoDataForPreview"});
//     const DynamicFormRef = useRef<any>();
//     const FormulaObjectRef = useRef<any>({});
//     const dependencyObjectRef = useRef<any>({});

//     const conditionObjectRef = useRef<any>({});
 
//     const selectedFromDynamicDictionary=useRef<any>()

    
 

//     let condiObject = {
//             checkBox3:"DynamicFormData.checkBox2"
//         }

//  function CalculateCallBack(value , inputKey){ 
//         if(value !=null && value!=undefined){
//             setDynamicFormData((prev)=> {return {...prev , [inputKey] :value}})
//         }
//         selectedFromDynamicDictionary.current=inputKey
//     }

//     console.log(FormulaObjectRef.current,'lej');
    
    
//     const handleInput = (event) => {
    
//         let newObject:any ={};
//         for (let key in FormulaObjectRef.current) {
//             // for(let key1 in dependencyObjectRef.current){
//             //     if (key1==key) return
//             // }
//             if(FormulaObjectRef.current[key]!="string" && FormulaObjectRef.current[key]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current[key]){
//               const isPrice= inputs.flatMap(item=>item.inputList).find(item=>item?.SystemKey==key)   
//             let preValue = DynamicFormRef.current[key].value
//               const activeElement=event.target.tagName === "INPUT"?event.target:  document.activeElement   as any
//               if(activeElement?.name==key ||( !FormulaObjectRef.current[key].includes(activeElement?.name) && activeElement.name)|| (!FormulaObjectRef.current[key].includes(selectedFromDynamicDictionary?.current) && selectedFromDynamicDictionary?.current && (!activeElement.name || activeElement.name==selectedFromDynamicDictionary.current))){
//                    if(isPrice?.initialSystemKey=="price"){
//                     }else{
//                                 DynamicFormRef.current[key].value = DynamicFormRef.current[key].value || ""
//                         }}
//              else
//                 {
//                     if(isPrice?.initialSystemKey=="price"){
//                      DynamicFormRef.current[key].value =GroupingPriceFunction(isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace==0? RoundWithExcelMethod((data?.[key] && mode=='view')?data?.[key]: (eval(FormulaObjectRef.current[key])!= Infinity?eval(FormulaObjectRef.current[key]):preValue ),isPrice?.currencyRoundingPlace):(data?.[key] && mode=='view')?data?.[key]: (eval(FormulaObjectRef.current[key])!= Infinity?eval(FormulaObjectRef.current[key]):preValue ))
//                               }else{
//                                         DynamicFormRef.current[key].value = (data?.[key] && mode=='view')?data?.[key]: (eval(FormulaObjectRef.current[key])!= Infinity?eval(FormulaObjectRef.current[key]):preValue )
//                                 }
//               setTimeout(() => {
//                 if((eval(FormulaObjectRef.current[key])||eval(FormulaObjectRef.current[key])==0) &&(preValue==""? true :  preValue !=eval(FormulaObjectRef.current[key])) && eval(FormulaObjectRef.current[key]) != Infinity ){
//                     DynamicFormRef.current[key].dispatchEvent(new Event('input', { bubbles: true }));

//                     }
//              }, 0);
//         }     
//            newObject = {...newObject , [key]:activeElement?.name==key || (!FormulaObjectRef.current[key].includes(activeElement?.name) && activeElement.name)|| (!FormulaObjectRef.current[key].includes(selectedFromDynamicDictionary?.current) && selectedFromDynamicDictionary?.current && (!activeElement.name || activeElement.name==selectedFromDynamicDictionary.current))?isPrice?.initialSystemKey=="price"?RoundWithExcelMethod(DynamicFormRef.current[key].value || 0,isPrice?.currencyRoundingPlace):   DynamicFormRef.current[key].value || "": eval(FormulaObjectRef.current[key]) }
//         }
//         }
//       //  setData({...data ,...newObject })
//        selectedFromDynamicDictionary.current=null
//     };

// //     useEffect(()=>{
// //         if(Object.keys(FormulaObjectRef.current)){
           

// // Object.keys(FormulaObjectRef.current).map(item=>{
// //    let x=DynamicFormRef.current ? (DynamicFormRef.current?.[item] as any)?.value =eval(FormulaObjectRef.current?.[item])}):null

// //         }
// //     },[Object.keys(FormulaObjectRef.current).map(item=>DynamicFormRef.current?.[item]?.value)])
    
//     const handleSubmit = async(event,withAttach=null,showReferenceStepper=false) => {  
//         event.preventDefault()
//         if(DynamicFormRef.current.reportValidity() ){
//           const obj :any= {}
//         const DataGrids :any= {}
//         inputs.map(card=>{
//             card?.inputList.map(input=>{
//           if( (conditionObjectRef.current?.[input.SystemKey]?.length > 0 ?eval(conditionObjectRef.current?.[input.SystemKey]) : true ) && (conditionObjectRef.current?.[input.StepIndex]?.length > 0 ?eval(conditionObjectRef.current?.[input.StepIndex]) : true ) &&  (step == card.stepNumber||step==null||step=="")&&input?.SystemKey !=undefined &&input.typeName != 'step'  ){
//                     if(input.typeName == 'textArea'|| input.typeName == 'items' || input.typeName == 'activityStatus' ||input.typeName == 'SystemNumber' || input.typeName == 'selectBox' ||input.typeName == 'text'|| input.typeName == 'number' || input.typeName === "decimalNumber" || input.typeName == 'price' ||  input.typeName == 'RadioButton'||  input.typeName == 'radio' ){
//                     obj[input.SystemKey] = (input.typeName == 'text' && input?.InputType == 6 ) ? DynamicFormRef.current[input.SystemKey].value  :DynamicFormRef.current[input.SystemKey].value? DynamicFormRef.current[input.SystemKey].value :null 
//                 }else if(input.typeName == 'timeLength'){
//                     obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey][0].value ?DynamicFormRef.current[input.SystemKey][0].value:null
//                 }else if(input.typeName == 'checkBox'){
//                     obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey].checked+""
//                 }else if(input.typeName == 'date' ||input.typeName == 'time' ){
//                     obj[input.SystemKey] = times[input.SystemKey] ?times[input.SystemKey]:null   
//                 }else if(input.typeName == 'Position' ||input.typeName == 'Person' ){
//                     obj[input.SystemKey+"Description"] =  DynamicFormRef.current[input.SystemKey+"Description"].value
//                     obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey].value  ?DynamicFormRef.current[input.SystemKey].value    :null  
//                 }
//                 else if(input.typeName == 'slider'){
//                     obj[input.SystemKey] = +DynamicFormRef.current[input.SystemKey].value ?+DynamicFormRef.current[input.SystemKey].value:null 
//                 } else if(input.type == 16){
//                     DataGrids[input.SystemKey] = rowsData[input.SystemKey]   
//                 }else if (input.typeName == 'PositionDictionary') {
//                     obj[input.SystemKey] = DynamicFormRef.current?.["RequesterPositionId"].value ?DynamicFormRef.current?.["RequesterPositionId"].value:null;
//                     obj["RequesterPositionDescription"] = DynamicFormRef.current["PositionDictionaryDescription"].value;
//                   //  obj.typeNames={...obj.typeNames,[input.SystemKey]:input.typeName}
//                  }else if(input.backendType == 'guid'||input.type==InputTypes.DynamicDictionary ) {
//                     obj[input.SystemKey+"Description"] =  DynamicFormRef.current[input.SystemKey+"Description"].value
//                    // obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey].value?DynamicFormRef.current[input.SystemKey].value:null  
                  
//                     obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey+"value"]?.value? DynamicFormRef.current[input.SystemKey+"value"].value:(DynamicFormRef.current[input.SystemKey]?.value ?DynamicFormRef.current[input.SystemKey]?.value:null)  

//                  }
//                  else if(input.typeName == 'url') {
//                     if(input?.inputType=="AutoCompleteDictionary")   obj[input.SystemKey+"Description"] =  DynamicFormRef.current['browser'+input.SystemKey].value
//                    // obj[input.SystemKey] = DynamicFormRef.current[input.SystemKey].value?DynamicFormRef.current[input.SystemKey].value:null  
//                     obj[input.SystemKey] =  DynamicFormRef.current[input.SystemKey]?.value?DynamicFormRef.current[input.SystemKey].value:null

//                  }
//             }
//             })
//         })
//     //  inputs.flatMap(item => item.inputList).map((input)=>{
//     //             if( (conditionObjectRef.current?.[input.SystemKey]?.length > 0 ?eval(conditionObjectRef.current?.[input.SystemKey]) : true ) && (conditionObjectRef.current?.[input.StepIndex]?.length > 0 ?eval(conditionObjectRef.current?.[input.StepIndex]) : true ) &&  (step == input.StepIndex||step==null||step=="")&&input?.SystemKey !=undefined &&input.typeName != 'step'  ){
//     //                 if(input.typeName == 'textArea'|| input.typeName == 'SystemNumber' || input.typeName == 'selectBox' ||input.typeName == 'text'||input.typeName == 'number' || input.typeName == 'price' ||  input.typeName == 'RadioButton'||  input.typeName == 'radio' ){
//     //                 obj[input.SystemKey] = (input.typeName == 'text' && input?.InputType == 6 ) ? event.target[input.SystemKey].value  : event.target[input.SystemKey].value  
//     //             }else if(input.typeName == 'timeLength'){
//     //                 obj[input.SystemKey] = event.target[input.SystemKey][0].value 
//     //             }else if(input.typeName == 'checkBox'){
//     //                 obj[input.SystemKey] = event.target[input.SystemKey].checked+""
//     //             }else if(input.typeName == 'date' ||input.typeName == 'time' ){
//     //                 obj[input.SystemKey] = times[input.SystemKey]    
//     //             }else if(input.typeName == 'Position' ||input.typeName == 'Person' ){
//     //                 console.log("input.SystemKey+ " ,input.SystemKey+"Description")
//     //                 obj[input.SystemKey+"Description"] =  event.target[input.SystemKey+"Description"].value
//     //                 obj[input.SystemKey] = event.target[input.SystemKey].value    
//     //             }
//     //             else if(input.typeName == 'slider'){
//     //                 obj[input.SystemKey] = +event.target[input.SystemKey].value  
//     //             } else if(input.type == 16){
//     //                 DataGrids[input.SystemKey] = rowsData[input.SystemKey]   
//     //             }else if (input.typeName == 'PositionDictionary') {
//     //                 obj[input.SystemKey] = event.target?.["RequesterPositionId"].value;
//     //                 obj["RequesterPositionDescription"] = event.target["PositionDictionaryDescription"].value;
//     //               //  obj.typeNames={...obj.typeNames,[input.SystemKey]:input.typeName}
//     //              }else if(input.backendType == 'guid'||input.type==InputTypes.DynamicDictionary ) {
//     //                 obj[input.SystemKey+"Description"] =  event.target[input.SystemKey+"Description"].value
//     //                // obj[input.SystemKey] = event.target[input.SystemKey].value?event.target[input.SystemKey].value:null  
                  
//     //                 obj[input.SystemKey] = event.target[input.SystemKey+"value"]?.value? event.target[input.SystemKey+"value"].value:(event.target[input.SystemKey]?.value ?event.target[input.SystemKey]?.value:null)  

//     //              }
//     //         }
//     //     })
//         if(mode == 'edit'){          
//             if(ReferenceId)  {
//                 await  putInformationFormWorkflow(ReferenceId,formKey,` ${JSON.stringify({JsonData :obj ,PRJ_UID: PRJ_UID,DataGrids:DataGrids })} `)
//             }else{
//                 await  putInformationForm(id,formKey,` ${JSON.stringify({JsonData :obj ,PRJ_UID: PRJ_UID,DataGrids:DataGrids })} `)

//             }
//             onHide && onHide(true)   
//             }else if(mode == 'create'){
//                 const res = await postDataForm(formKey,` ${JSON.stringify({JsonData :obj ,PRJ_UID: PRJ_UID,DataGrids:DataGrids })} ` ,PRJ_UID,withAttach?true:false)
                
//                 if (showReferenceStepper) {
//                     handleShowReferenceStepper && handleShowReferenceStepper(!(res.MessageType ==MessageType.success) ? false:res.Data);
//                 } else {
//                     onHide && onHide(true) 
//                 }
                
//                       if(res.Data){ callAttachmentMoveTemp &&   callAttachmentMoveTemp(res.Data)
//         }
//           reload && reload ()
//             }
//             try {
           
//         } catch (error) {
            
//         }
            
//         }
     
//     }

// // const CalculateRoundingPlace=(e)=>{
// //     let newObject:any ={};
// //     for (let key in FormulaObjectRef.current) {
// //         if(FormulaObjectRef.current[key]!="string" && FormulaObjectRef.current[key]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current[key]){
// //           const isPrice= inputs.flatMap(item=>item.inputList).find(item=>item?.SystemKey==key)
// //                 DynamicFormRef.current[key].value =GroupingPriceFunction( RoundWithRoundingPlace(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace))
// //             let preValue =GroupingPriceFunction(RoundWithRoundingPlace(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace)) 
// //             setTimeout(() => {
// //                 if((eval(FormulaObjectRef.current[key])||eval(FormulaObjectRef.current[key])==0) &&(preValue==0? true :  preValue !=eval(FormulaObjectRef.current[key])) && eval(FormulaObjectRef.current[key]) != Infinity ){
// //                     DynamicFormRef.current[key].dispatchEvent(new Event('input', { bubbles: true }));

// //                     }
// //              }, 0);
// //           //  newObject = {...newObject , [key]: RoundWithRoundingPlace(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace)}
// //         }
// //         }


    
// // }


// const CalculateRoundingPlace=(e,systemKey)=>{
//     let newObject:any ={};
//         if(FormulaObjectRef.current?.[systemKey]!="string" && FormulaObjectRef.current?.[systemKey]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current?.[systemKey]){
//           const isPrice= inputs.flatMap(item=>item.inputList).find(item=>item?.SystemKey==systemKey)          
//           DynamicFormRef.current[systemKey].value =GroupingPriceFunction(isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace==0? RoundWithExcelMethod(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace):e?.replaceAll(',','') || 0)
//           let preValue =GroupingPriceFunction(isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace==0?RoundWithExcelMethod(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace):e?.replaceAll(',','') || 0) 
//           setTimeout(() => {
//               //  if((eval(FormulaObjectRef.current?.[systemKey])||eval(FormulaObjectRef.current?.[systemKey])==0) &&(preValue==0? true :  preValue !=eval(FormulaObjectRef.current?.[systemKey])) && eval(FormulaObjectRef.current?.[systemKey]) != Infinity ){
//                     DynamicFormRef.current?.[systemKey].dispatchEvent(new Event('input', { bubbles: true }));

//                    // }
//              }, 0);
//         }
// }







// const setCodeCallback=(object,systemKey)=>{

//     DynamicFormRef.current[systemKey].value =object.Code
//     //    if(dependencyObjectRef.current?.[systemKey]!="string" && dependencyObjectRef.current?.[systemKey]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current?.[systemKey]){
       
    
    
    
    
    
    
    
    
//     for (let key in dependencyObjectRef.current) {


// if( dependencyObjectRef.current[key]?.split('.')?.[0]==systemKey){
// let x=dependencyObjectRef.current[key]?.replaceAll([systemKey],"object")


//            // if(FormulaObjectRef.current[key]!="string" && FormulaObjectRef.current[key]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current[key]){
//             let preValue = DynamicFormRef.current[key].value
                  
//              DynamicFormRef.current[key].value = (data?.[key] && mode=='view')?data?.[key]: (eval(x)!= Infinity?eval(x):preValue )
                                
//               setTimeout(() => {
//                 if((eval(x)||eval(x)==0) &&(preValue==""? true :  preValue !=eval(x)) && eval(x) != Infinity ){
//                     DynamicFormRef.current[key].dispatchEvent(new Event('input', { bubbles: true }));

//                     }
//              }, 0);
        
//         //}
//        // }
//       //  setData({...data ,...newObject })
//        selectedFromDynamicDictionary.current=null









//           setTimeout(() => {
//               //  if((eval(FormulaObjectRef.current?.[systemKey])||eval(FormulaObjectRef.current?.[systemKey])==0) &&(preValue==0? true :  preValue !=eval(FormulaObjectRef.current?.[systemKey])) && eval(FormulaObjectRef.current?.[systemKey]) != Infinity ){
//                     DynamicFormRef.current?.[systemKey].dispatchEvent(new Event('input', { bubbles: true }));

//                    // }
//              }, 0);
//         }
// }


// }




//     async function getFormByKeyAsync(formKey) {
//         setLoading(false)
//         try{
          
//           const respons = await getFormByKey(formKey,ReferenceId as any , PRJ_UID,parentISCartable,formBuilderPage)
//           setInputs(JSON.parse( respons.Data?.DynamicForms.FormFields)?.inputList)
//          setShowAttachmentByDynamicForm && setShowAttachmentByDynamicForm(JSON.stringify(
//          JSON.parse( respons.Data?.DynamicForms.FormFields)?.inputList.flatMap(item=>item.inputList)
//           ).includes('initialSystemKey":"attachment'))
//           FormulaObjectRef.current = JSON.parse( respons.Data?.DynamicForms.FormFields)?.formula
//           dependencyObjectRef.current=JSON.parse( respons.Data?.DynamicForms.FormFields)?.dependency
//           conditionObjectRef.current = JSON.parse( respons.Data?.DynamicForms.FormFields)?.condition
//           setCatchMessage({type:"info",msg:"NoDataForPreview"})

//         }catch(err:any){
//             setCatchMessage({type:"error" , msg:err?.response?.data?.Message})

//         }
//         setLoading(true)
//       }


//     async function getFormInformationAsync() {
//         setDataLoading(false)
//         try{
//             if(ReferenceId){
//                 const respons = await getFormInformationByReferenceId((ReferenceId),formKey)
//                 setData({...respons?.Data.DynamicFormData , ...respons?.Data.DataGrids})
//                  buttonPrintObjCallBack&& buttonPrintObjCallBack({
//                   Id: respons.Data.DynamicFormData.Id,
//                   reportDomain:"DynamicForm",
//                   objectTag:formKey,
//                   apiFunction:getDataForPrint,
//                   params:{formKey:formKey}
//                 })
                
//             }else{
//                 const respons = await getFormInformationById((id),formKey)
//                 setData({...respons?.Data.DynamicFormData , ...respons?.Data.DataGrids})
//                      buttonPrintObjCallBack&& buttonPrintObjCallBack({
//                       Id: respons.Data.DynamicFormData.Id,
//                       reportDomain:"DynamicForm",
//                       objectTag:formKey,
//                       apiFunction:getDataForPrint,
//                       params:{formKey:formKey},
//                     })
//             }
//           setCatchMessage({type:"info",msg:"NoDataForPreview"})
          
//           }catch(err:any){
//             setCatchMessage({type:"error" , msg:err?.response?.data?.Message})

//           }
          
//           setDataLoading(true)
//     }
    

//     const DynamicFormTranslateAsync=async()=>{
//         try{
//             const response=await DynamicFormTranslate(formKey)
//             modalFormLabelCallBack(response?response:'')
//         }
//         catch(error){}
//     }
//     useEffect(()=>{
//         if(mode != 'create'&&(jobId ||id||ReferenceId)) {
//             getFormInformationAsync()
//         }
//         if(defaultInputList){
//             setInputs(defaultInputList)
//         }else{
//             getFormByKeyAsync(formKey)
//         }
//         if(dataEntry){
//             DynamicFormTranslateAsync()
//         }
//     },[defaultInputList])

    

//     return ( 

//         <>
//         {(loading&&dataLoading) ?
//            <>
//            {(inputs&& data)?
//             <form ref={ DynamicFormRef} action="" onSubmit={(e)=>{handleSubmit(e)}} onInput={handleInput}>
//                 <div className="card mx-2 mt-1 formBuilder__formBx" style={{height:'fit-content'}}>
//                     <div className="row">
//                        {inputs.map((card , cardIndex)=>(
//                          <React.Fragment key={cardIndex}>
//                          {(step >= card.stepNumber||step==null||step=="") ? 
//                          <div  
//                          style={{minHeight:openStepStatus[cardIndex]===false?"0px":"100px" , flexDirection:"row"}} className={`card row mx-0  px-0  
//                               ${(conditionObjectRef.current?.[card.SystemKey] &&( !eval(conditionObjectRef.current?.[card.SystemKey])) )?"noneImpo" :"d-flex"}
//                          `}>
//                        <div style={{ backgroundColor: "#cfe2ff", paddingRight: "20px", justifyContent: "space-between" }} className={`formBuilder__formBx__items not-active  d-flex  py-1 col-12 pr-4`}>
//                                <div>{card.label=='card'?trans(card.label):card.label  } </div>
//                            <div style={{ marginLeft: "18px" }} onClick={() => setOpenStepStatus(pre=>{return{...pre ,[cardIndex]:(pre[cardIndex]||pre[cardIndex]==undefined)? false : true}})} >{(openStepStatus[cardIndex]===false )? <FontAwesomeIcon icon={[ICON_TYPE, "angle-down"]} size="lg" className="icon" /> : <FontAwesomeIcon icon={[ICON_TYPE, "angle-up"]} size="lg" className="icon" />}</div>
//                        </div>
//                         <>
                        
//                          {card.inputList.map((Obj, index) => {
//                             if ((Obj.typeName=="button" && window.location.href.includes('cartable')) || Obj.typeName=="attachment") return null
//                            return (
//                                 <React.Fragment key={index}>
//                                  <div key={index} id={"inputsId"+index}
                                   
//                                   className={` align-items-start formBuilder__formBx__active col-${Obj.size} formBoxDr in   ${( openStepStatus[cardIndex]===false  ||(conditionObjectRef.current?.[Obj.SystemKey]?.length > 0 && !eval(conditionObjectRef.current?.[Obj.SystemKey]))||
//                                     (conditionObjectRef.current?.[Obj.StepIndex]?.length > 0 && !eval(conditionObjectRef.current?.[Obj.StepIndex])))?"noneImpo" :"d-flex"}
//                                     `}  >
//                                  <div className={`d-flex ${Obj.typeName == 'checkBox' ?'align-items-center' :'align-items-start'} h-100 justify-content-between w-100 formBoxDr iwn`} id={index}>
//                                      <InputDetector
//                                      setCodeCallback={setCodeCallback}
//                                      CalculateRoundingPlace={CalculateRoundingPlace}
//                                      onClick={Obj.typeName=="button" && Obj?.viewAttachment?(e)=>{
//                                          e.preventDefault()
//                                         if(mode=="edit"){//اگر فرم در مد مشاهده یا ادیت باز شود دیگه نباید با کلیک روی دکمه داینامیک  ، فرم و ارسال کنیم و فقط باید پیوست باز بشه و اگر در مد ایجاد باشه باید هم ارسال بشه و هم پیوست باز بشه
                            
//                                             handleCallAttachment(ReferenceId)
//                                              onHide && onHide(true) 

//                                         }else if(mode=='create'){
//                                             handleSubmit(e,'withAttach' as any)
//                                         }
                                        
//                                     }:()=>{
                                   
//                                      }} 
                                     
                             

//                                      useOnInput={true}  handleOpenStep={(e)=>{setOpenStepStatus(pre=>{return{...pre ,[Obj.StepIndex]:e }})}} CalculateCallBack={CalculateCallBack} dataEntry={dataEntry} mode={((step > card.stepNumber &&(step!=null||step!="") || Obj.SystemKey=='SystemNumber') ? "view" :mode)  }    typeName={Obj.typeName}  property={{ ...Obj, defaultValue:
                                        
//                                     //     Obj.initialSystemKey=="price"?
                                        
//                                     //    Obj?.currencyRoundingPlace || Obj?.currencyRoundingPlace==0? RoundWithExcelMethod(data?.[Obj.SystemKey]?  (data?.[Obj.SystemKey]+"")?.replaceAll(',',''):Obj?.defaultValue?.replaceAll(',',''),Obj?.currencyRoundingPlace):data?.[Obj.SystemKey]?data?.[Obj.SystemKey]+""?.replaceAll(',',''):Obj?.defaultValue?.replaceAll(',','')
                                        
//                                     //     :
                                        
//                                         data?.[Obj.SystemKey]?data?.[Obj.SystemKey]:Obj?.defaultValue
                                    
                                    
                                    
                                    
//                                     }}  handleRowsData={(e)=>{setRowsData({...rowsData ,[Obj?.SystemKey]: e })}} handleTime={(e) => { setTimes({ ...times, [Obj.SystemKey]: e }); } } changeProperty={function (e: any): void {
//                                            throw new Error("Function not implemented.");
//                                         } }/>  
//                                  </div>
//                                  </div>
//                             </React.Fragment>
//                            );
//                          })}                          
//                         </>
//                          </div>

//                                 :
//                          <></>
                         
                         
//                          }

//                          </React.Fragment>
//                        ))}
       
//                     </div>
//                 <div className="col-lg-12 btns_form">
//                     {mode != 'view' ?
//                         <div className="py-2"> 
                          
//                          {(handleShowReferenceStepper &&     (step==1 || mode == "create")) && (
//                             <Button
//                               btnType="submit"
//                               value="SaveAndReference"
//                               onClick={(e) => {handleSubmit(e,null,true);}}
//                             />
//                           )}
//                             <Button btnType="submit" value="Save" onClick={handleSubmit}/>
//                             <Button btnType="cancel" value="cancel" onClick={()=>{onHide && onHide(false)}} /> 
//                         </div>
//                     :
//                     <div className="m-1">
//                         {/* <Button btnType="primary" value="copy" onClick={()=>{handleCopy && handleCopy(formKey)}} /> */}
//                         <Button btnType="primary" value="close" onClick={()=>{onHide && onHide(false)}} /> 
//                     </div>
//                     }
//                 </div> 
//             </div>
//             </form>
//            : <Message message={catchMessage.msg} type={catchMessage.type} />
//            }
//            </>
//            :
//            <Loading />
//         }
//         </>
//      );
// }




